import { sourceFrameThumbnailUrl as sourceFrame } from '@src/utility/story';

import type { Story } from '@src/types.ts/story';

/**
 * A frame from the source video at a given media time.
 *
 * Shared by the Section rows and the Add Clips picker (PLAT-11057) so a clip
 * and the Section it becomes show the same frame. The resolution itself lives
 * in `src/utility/story.ts` — the caption-style previews need the same
 * source-footage frame, and a feature folder is the wrong home for something
 * two features read.
 */
export function sourceFrameThumbnailUrl(
  story: Story | null | undefined,
  mediaStartTime: number,
): string | undefined {
  return sourceFrame(story, mediaStartTime, { width: 128, height: 72 });
}
